import FormRow from '../../FormRow'
import { Checkbox, Select } from '../../../../react-final-form-wrappers'
import { client } from '../../../../client'
import TreatmentProgramSelector from './TreatmentProgramSelector'
import { PlusCircle } from 'mdi-material-ui'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { AlertDialog } from '../../../../components/AlertDialog'
import Grid from '@material-ui/core/Grid'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Radios, TextField } from 'mui-rff'
import { useState } from 'react'
import useEffectAsync from '../../../../hooks/useEffectAsync'
import Field from '../../../../react-final-form-wrappers/Field'

const TreatmentProgramSection = () => {
  const { patientId, treatmentProgramId } = useParams<{
    patientId: string
    treatmentProgramId: string
  }>()
  const { t } = useTranslation('treatmentProgramSection')
  const [treatmentProgramUUID, setTreatmentProgramUUID] = useState<
    string | null
  >(null)

  const handleCreateProgram = async () => {
    if (!patientId || !treatmentProgramId) return
    
    const program = await client.addTreatmentProgram(
      { patient: { id: parseInt(patientId) } },
      parseInt(treatmentProgramId)
    )
    window.location.href = `/clienten/${patientId}/trajecten/${program.id}`
  }

  const handleRemoveProgram = async () => {
    if (!patientId || !treatmentProgramId) return
    
    await client.removeTreatmentProgram(parseInt(treatmentProgramId))
    const programIds = await client.getSortedTreatmentPrograms(parseInt(patientId))
    if (programIds.length) {
      const latestProgramId = programIds[programIds.length - 1]
      window.location.href = `/clienten/${patientId}/trajecten/${latestProgramId}`
    } else {
      window.location.href = '/'
    }
  }

  useEffectAsync(async () => {
    if (!treatmentProgramId) return
    
    const treatmentProgram = await client.getTreatmentProgramById(
      treatmentProgramId
    )
    if (treatmentProgram.uuid) setTreatmentProgramUUID(treatmentProgram.uuid)
  }, [treatmentProgramId])

  const languageOptions = [
    { label: t('dutch'), value: 'nl' },
    { label: t('english'), value: 'en' }
  ]

  return (
    <>
      <Grid container direction="row">
        <Grid item>
          <TreatmentProgramSelector />
        </Grid>
        <Grid item>
          <IconButton aria-label="Add" onClick={handleCreateProgram}>
            <PlusCircle color="primary" />
          </IconButton>
        </Grid>
        <Grid item>
          <AlertDialog
            text={t('alertDialogText')}
            title={t('alertTitle')}
            cancelText={t('alertCancel')}
            confirmText={t('alertConfirm')}
            onConfirm={handleRemoveProgram}
            render={({ onClick }: { onClick: () => void }) => (
              <IconButton aria-label="Add" onClick={onClick}>
                <DeleteIcon color="disabled" />
              </IconButton>
            )}
          />
        </Grid>
      </Grid>
      <FormRow>
        <TextField
          style={{ width: 300 }}
          name="treatmentType.uuid"
          label={t('UUID')}
          value={treatmentProgramUUID || ''}
          // @ts-ignore not sure if it works, but let's not break it if it does
          readOnly
        ></TextField>
      </FormRow>
      <FormRow>
        <TextField
          style={{ width: 300 }}
          name="treatmentType.productCode"
          label={t('productCode')}
          value={treatmentProgramId || ''}
          // @ts-ignore not sure if it works, but let's not break it if it does
          readOnly
        ></TextField>
      </FormRow>
      <FormRow>
        <Select
          style={{ width: 300 }}
          label={t('practiceLabel')}
          getOptionLabel={(i: any) => i.name}
          getOptionValue={(i: any) => i.id}
          getOptions={async () => client.getPracticeOptions(true)}
          name="practice.id"
        />
      </FormRow>
      <FormRow>
        <Select
          style={{ width: 300 }}
          label={t('treatmentType')}
          getOptions={async () => client.getTreatmentTypeOptions()}
          getOptionLabel={(i: any) => i.name}
          getOptionValue={(i: any) => i.id}
          name="treatmentType.id"
          MenuItemProps={(i: any) => {
            return {
              disabled: i.id === 1 // Generalistische Basis GGZ (2021 en eerder) - outdated treatmentType
            }
          }}
        />
      </FormRow>
      <FormRow>
        <TextField
          fullWidth
          multiline
          name="initialRemarks"
          label={t('remarksLabel')}
        />
      </FormRow>
      <FormRow>
        <Grid container direction="row" spacing={5}>
          <Grid item>
            <Field
              type="checkbox"
              name="funnel.onsite"
              label={t('onsite')}
              component={Checkbox}
            />
          </Grid>
          <Grid item>
            <Field
              type="checkbox"
              name="funnel.online"
              label={t('online')}
              component={Checkbox}
            />
          </Grid>
        </Grid>
      </FormRow>
      <FormRow>
        <Radios
          color="primary"
          label={t('language')}
          name="funnel.language"
          data={languageOptions}
          radioGroupProps={{
            row: true
          }}
        />
      </FormRow>
    </>
  )
}

export default TreatmentProgramSection
